export function getAssigneeName(assignee) {
  if (!assignee) {
    return 'Assignee'
  }
  return `${assignee.user?.vaxiom_person?.first_name || 'Support'} ${assignee.user?.vaxiom_person?.last_name || ''}`
}
